const ApiConst = {
    BaseUrl: '/'
};

export default ApiConst;